import { ScrollView } from 'react-native'
import { useIsBenefitScreenPresentedAsModal } from '@/src/experiences/card-benefits/components/BenefitModal'
import type { ComponentProps } from 'react'
import { CardBenefitsE2E } from '@/src/experiences/card-benefits/e2e'

export function CardBenefitsComponentsScroll(props: ComponentProps<typeof ScrollView>) {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      contentContainerStyle={!isBenefitScreenPresentedAsModal && { paddingTop: 16 }}
      testID={CardBenefitsE2E.Ids.View.BenefitScroll}
      {...props}
    />
  )
}
